import { MRT_RowData } from "material-react-table";
import { CustomMRTFilter } from "../mrt.types";
import { DisplayApi, filterValueOf } from "./SelectOneFromFilter";

type OneFromManyOptions<T extends MRT_RowData, SelectData> = {
    mrtProps: CustomMRTFilter<T>;
    selectedItem: SelectData | undefined;
    selectOptions: DisplayApi<SelectData>;
    newValues: SelectData[];
};
export const onChangeOneFromMany = <T extends MRT_RowData, SelectData>(options: OneFromManyOptions<T, SelectData>) => {
    const { newValues, mrtProps, selectOptions, selectedItem } = options;

    if (newValues.length === 0) {
        mrtProps.column.setFilterValue(null);
        return;
    }

    if (selectedItem === undefined) {
        // No items was previously selected, I simply add a new one.
        mrtProps.column.setFilterValue(filterValueOf(selectOptions, newValues[0]));
        return;
    }

    const newFilterToUse = newValues.find((i) => {
        // I want to match the one that doesn't match explictly
        return filterValueOf(selectOptions, i) !== filterValueOf(selectOptions, selectedItem);
    });

    // There must be one, but just in case;
    if (newFilterToUse === undefined) return;

    const newFilterValue = filterValueOf(selectOptions, newFilterToUse);
    mrtProps.column.setFilterValue(newFilterValue);
};
